<template>
    <wizard-step-card
            header="Meldung abgeschlossen!"
            :reason="_getCurrentReason"
            :btnDoneName="false"
            btn-abbort-name="Beenden"
            v-on:abbort="$emit('abbort')"
    >

        <div class="row">

            <div class="col-6 offset-3 text-center">

                <h2>Sie haben es geschafft!</h2>

                <check-animation> </check-animation>


                <div class="mb-4"> <b>Vielen Dank für Ihre Mitarbeit!</b> </div>
                <p>
                    Ihre Meldung wurde unserem Kundenservice mitgeteilt und wir werden Ihren Fall schnellstmöglich bearbeiten!
                </p>


            </div>

        </div>

    </wizard-step-card>
</template>

<script>
    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'
    import CustomerDiscription from '../../elements/CustomerDiscription'
    import CheckAnimation from '../../elements/CheckAnimation'

    export default {
        name: "finshed",
        components: {
            InfoHeader,
            WizardStepCard,
            CustomerDiscription,
            CheckAnimation
        },

        computed: {
            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Fehler - nicht gefunden!'
            },
        },

        methods: {
            sendMail2Service () {

                let form = this.$store.getters.getForm

                this.$RestClient.sendMail2Service( form )
                    .then(data => {
                        console.log(data)
                    })
            }
        },

        mounted () {
            this.sendMail2Service()
        }
    }
</script>

<style scoped>

</style>